import { Box, Button, Typography } from "@mui/material"
import Question from "./question"
import { QuestionType } from "../types/types"

interface IFormProps {
    questions: QuestionType[]
    onAnswerChange: (questionId: number, answer: number) => void
    getResult: () => void
}

const Form = ({questions, getResult, onAnswerChange}: IFormProps) => {
    return(
        <>
            '<Box textAlign='center' marginX={{xs: 5, sm: 10}}>
                <Typography variant="h1">
                    Descubra a Deusa que Habita em Você
                </Typography>
                <Typography variant="h5">
                    Dentro de cada mulher, existe uma essência única que pulsa e guia sua vida. Essa essência é repesentada pelos arquétipos das deusas, energias femininas que influenciam seus comportamentos, escolhas e maneira de enxergar o mundo.
                    Este teste foi criado para ajudá-la a explorar qual deusa está mais presente em sua vida neste momento. Será Afrodite, a deusa do amor e da beleza? Atena, a deusa da sabedoria e da estratégia? Ou talvez Démeter, Hera, Perséfone ou Ártemis?
                    Responda com sinceridade e descubra a força feminina que habita em você.
                    Pronta para o despertar? Vamos lá!
                </Typography>
            </Box>
            
            <br/>

            {
                questions.map((question) => (
                    <Question
                        question={question}
                        onChange={onAnswerChange}
                    />
                ))
            }

            <Button sx={{marginX: {xs: 5, sm: 10}, marginY: 5}} size="large" color="error" variant="contained" onClick={getResult}>
                Ver Resultado
            </Button>
        </>
    )
}

export default Form